import { isMobile } from '../../util';

const OrderConfirmationBanner = ({
    accountId, sourceId, retailerId, placementId
}) => {
    return (
        <div className='surfside-menu-banner surfside-confirmation-banner'>
            <surf-banner
                className='surf-ad-placement'
                account-id={accountId}
                channel-id="bf9bc"
                site-id={sourceId}
                placement-id={placementId}
                location-id={retailerId}
                keywords='complete'
                type='inline'
                adtypes='0,1'
                width={isMobile() ? "4" : "8"}
                height={1}
            ></surf-banner>
        </div>
    );
};

export default OrderConfirmationBanner;
